import { createApiAction } from '@app/packages/api/utils'
import type { ApiInaccurateLocation, ApiMapUser, ApiSitter } from '@app/packages/api/v2/types/entities'
import type { SitterSearchQuery } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export type SearchPageMeta = { total: number; total_pages: number; current_page: number }

export const getSitterSearch = (query: SitterSearchQuery) =>
  createApiAction('getSitterSearch', dispatch =>
    dispatch<{ data: ApiSitter[]; included?: unknown[]; meta: SearchPageMeta }>({ method: 'GET', endpoint: v2Path('/api/v2/search', query) })
  )

/**
 * The same endpoint trimmed to what the map needs. `fields[users]` still calls the type `users`,
 * so it is renamed here — a trimmed user must not land in the store as a whole one.
 */
export const getSearchUsersLocations = (query: SitterSearchQuery) =>
  createApiAction('getSearchUsersLocations', async dispatch => {
    const resp = await dispatch<{ data: (Omit<ApiMapUser, 'type'> & { type: 'users' })[]; included: ApiInaccurateLocation[]; meta: SearchPageMeta }>({
      method: 'GET',
      endpoint: v2Path('/api/v2/search', { ...query, 'fields[users]': 'token,name,inaccurate_location', include: 'inaccurate_location' }),
    })
    return { ...resp, data: resp.data.map(user => ({ ...user, type: 'map_users' as const })) }
  })
